/* eslint-disable no-console */
import Vue from 'vue'

const state = {
  isLoading: false
}

const getters = {
  
}

const actions = {
    upload ({ commit }, data) {
        return new Promise((resolve, reject) => {
          Vue.axios.post(`/api/1.0/certificationRequirements/${data.requirementId}/Upload`, data.formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then((resp) => {
              commit('UPLOAD_SUCCESS', resp)
              // dispatch('get')
              resolve(resp)
            })
            .catch((err) => {
              commit('UPLOAD_FAILURE', err)
              reject(err)
            })
        })
      }
}

const mutations = {
    UPLOAD_PENDING (state) {
        state.isLoading = true
      },
    UPLOAD_SUCCESS (state) {
        state.isLoading = false
    },
    UPLOAD_FAILURE (state, error) {
        state.isLoading = false
        console.log('Error uploading certification...')
        console.log(error)
    },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
